// Internal
import { logger } from '@/lib/logger';
import type { LogOnShippingChangeReceivedToFPTIPayload } from './types';

const logonShippingAddressChangeReceivedToFPTI = (
  payload: LogOnShippingChangeReceivedToFPTIPayload,
): void => {
  const { errorDescription = 'none', status } = payload;
  logger.fpti('checkout_merchant_shipping_calculation_received', {
    api_response: status,
    error_description: errorDescription,
    state_name: 'review',
    transition_name: 'process_review_merchant_shipping_calculation',
  });
};

const logShippingOptionsChangeReceivedToFPTI = (
  payload: LogOnShippingChangeReceivedToFPTIPayload,
): void => {
  const { errorDescription = 'none', status } = payload;
  logger.fpti('checkout_merchant_shipping_option_change_received', {
    api_response: status,
    error_description: errorDescription,
    state_name: 'review',
    transition_name: 'process_review_merchant_shipping_option_calculation',
  });
};

export {
  logonShippingAddressChangeReceivedToFPTI,
  logShippingOptionsChangeReceivedToFPTI,
};
